import QuickResult from "../../components/quickResult/QuickResult.jsx";

const CompanyQuickResult = () => <QuickResult />;

export default CompanyQuickResult;
